class CartDrawerProductForm extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * ### Method called when the element is attached to the DOM
   */
  connectedCallback() {
    // Elements
    this.form = this.querySelector("form");
    this.submitBtn = this.querySelector('button[type="submit"]');
    this.originalBtnInnerHTML = this.submitBtn.innerHTML;
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartCountBubble = document.querySelector("#cart-icon-bubble");

    // Event listeners
    this.form.addEventListener("submit", this.submitHandler.bind(this));
  }

  /**
   * ### Method called when the element is detached to the DOM
   */
  disconnectedCallback() {
    this.form.removeEventListener("submit", this.submitHandler, true);
  }

  /**
   * ### Submit event handler
   * @param {Event} event Form's submit event
   */
  async submitHandler(event) {
    // Prevent form default submission
    event.preventDefault();

    // Set loading state
    this.setLoadingState(true);

    // Get form data
    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData);

    // Check if the free shipping cookie is set
    const appliedFreeShipping = readCookie("autoapply_freshipping");
    if (appliedFreeShipping && appliedFreeShipping.trim() !== "") {
      // Add the _free_shipping_applied property
      if (!data.properties) {
        data.properties = {};
      }
      data.properties["_free_shipping_applied"] = true;
    }

    try {
      // Send POST request
      const response = await fetch(event.target.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      // If response successful, open the Cart
      if (response.ok) {
        this.openAndPopulateCart();
      }
    } catch (error) {
      console.error(`❌ 👉🏻 CartDrawerProductForm | submitHandler | ${error}`);
    } finally {
      this.setLoadingState(false);
    }
  }

  /**
   * ### Helper method to set the loading state
   * @param {Boolean} loading True/false value to set loading state
   */
  setLoadingState(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.innerHTML = loading
      ? "Processing..."
      : this.originalBtnInnerHTML;
    this.submitBtn.disabled = loading;
  }

  async openAndPopulateCart() {
    // Fetch the updated cart drawer content from the server
    const response = await fetch("/cart");
    const responseText = await response.text();

    // Parse the fetched HTML response into a DOM document
    const newCartMarkup = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Update cart icon bubble
    const newCartIconBubbleMarkup =
      newCartMarkup.querySelector("#cart-icon-bubble");
    this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

    // Remove empty class
    this.cartDrawer.classList.remove("is-empty");

    // Get new cart drawer markup
    const newCartDrawerMarkup = newCartMarkup.querySelector(
      "#CartDrawer #CartDrawer-CartItems"
    );

    // Replace markup
    this.cartDrawer
      .querySelector("#CartDrawer #CartDrawer-CartItems")
      .replaceWith(newCartDrawerMarkup);

    const newCartDrawerFooterMarkup = newCartMarkup.querySelector(
      "#CartDrawer .drawer__footer"
    );

    this.cartDrawer
      .querySelector("#CartDrawer .drawer__footer")
      .replaceWith(newCartDrawerFooterMarkup);

    // Open cart
    this.cartDrawer.open();

    this.cartDrawer.querySelector("cart-drawer-items").scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    document.querySelector("cart-drawer").hideInstallmentsCTA();
  }
}

customElements.define("cart-drawer-product-form", CartDrawerProductForm);
